import gql from 'graphql-tag'
import { areaSimpleFragment } from 'graphqlAPI/areas/fragments'

export const enrolExternalCourseFragment = gql`
  fragment EnrolExternalCourseFragment on EnrolExternalCourse {
    id
    attendance
    user {
      id
      name
      lastname
      avatar
      position
      abacRole {
        id
        name
        isDefault
      }
      area {
        ...AreaFragmentSimple
      }
    }
    state
    totalHours
    evaluations {
      id
      points
      externalCourseEvaluationId
    }
  }
  ${areaSimpleFragment}
`
